import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'peps-button',
	imports: [
		RouterLink
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './button.component.html',
})
export class ButtonComponent {

	@Input() text: string = '';
	@Input() link: string = '';
	@Input() hrefLink: string = '';

}
